export enum ChequebookStatus {
    Open = "Ihr eingereichter Nachweis liegt vor und wird in Kürze geprüft. ",
    Rejected = " Ihr eingereichter Nachweis konnte aktuell nicht gutgeschrieben werden. Details dazu finden Sie unter Ihren Mitteilungen. ",
    Accepted = "Ihr eingereichter Nachweis wurde gutgeschrieben.",
    InProgress = "Ihr eingereichter Nachweis befindet sich derzeit in der Prüfung/ Bearbeitung."
}